import { RedirectParams } from '../utils/route-helpers';
import { useLocalStorage } from './useLocalStorage';

export type SearchHistoryEntry = {
  searchKey: string;
  route: RedirectParams;
};

const HISTORY_SIZE = 5;

export const useSearchHistory = (suggestionGroupKey: string) => {
  const { get, set, clear } = useLocalStorage();

  const saveSearchKey = (searchEntry: SearchHistoryEntry): SearchHistoryEntry[] => {
    if (!searchEntry?.searchKey) {
      return;
    }

    // Clone current keys.
    const currentSearchHistory = [...((get(suggestionGroupKey) || []) as SearchHistoryEntry[])];

    // Clone current to next keys.
    const newSearchHistory = [...currentSearchHistory];

    // Find existing key.
    const existingIndex = newSearchHistory.findIndex((entry) => entry.searchKey === searchEntry.searchKey);

    // Remove existing key.
    if (existingIndex >= 0) {
      newSearchHistory.splice(existingIndex, 1);
    }

    // Push new key on top.
    newSearchHistory.unshift(searchEntry);

    // Save to local storage.
    set(suggestionGroupKey, newSearchHistory.slice(0, HISTORY_SIZE));

    return newSearchHistory;
  };

  const getSearchKeys = (): SearchHistoryEntry[] => {
    try {
      return get(suggestionGroupKey) || [];
    } catch (_) {
      return [];
    }
  };

  const clearSearchKeys = () => clear(suggestionGroupKey);

  return {
    saveSearchKey,
    getSearchKeys,
    clearSearchKeys,
  };
};
